<template>
  <section class="table-component" :class="[className,{'open-user-table': isUserPage && openUser}]">
    <!--таблица с легендой -->
    <ul class="table-legend">
      <li class="cell1">
        <!--кнопка отметить все -->
        <button type="button"
                @click="checkAll"
                :class="{'check-all_active': allChecked}"
                class="check-all">
        </button>
        <!---->
      </li>
      <!--легенда табилцы-->
      <li v-for="(legendItem, i) in legend"
          :key="legendItem + i"
          :style="{width: columnWidth[i] + '%'}"
          @click="filterItems(legendItem.filterMethod, i)"
          :class="[{'filter-item': true,
                  'active-filter': legendItem.activeFilter,
                  'legend-buttons': tableWithButtons,
                  'filter-item_gear': legendItem.isGear}, 'cell' + (+i + +2)]">
        <!--legend label-->
        <p class="legend-label" >
          {{legendItem.text}}
        </p>
        <!---->

        <!--filter icon-->
        <filer-icon v-if="legendItem.legendSort"
                    :up="legendItem.legendUp"
                    :down="legendItem.legendDown"></filer-icon>
        <!---->
      </li>
      <!---->
    </ul>
    <!---->

    <!--таблица с данными-->
    <ul class="table-component" v-if="columns">
      <li class="table-item"
          @dblclick.stop="dblClick(item.dblClick, item.dblClickPrefix, item.isItemProjects)"
          v-for="(item,i) in columns"
          :key="item.id">

        <!--кнопка отметить-->
        <div class="cell1" @click.stop="">
          <label class="check-cont_small check-cont">
            <input type="checkbox"
                   @change="changeCheckbox"
                   v-model="checkedItems"
                   :value="item.item">
            <p class="check-label"></p>
          </label>
        </div>
        <!---->

        <!--ячейки таблицы
        если есть аватарка - присваиваем класс
        стили получаем из пропсов-->
        <div v-for="(cell,j) in item.cells"
             :class="['cell' + (+j + 2), {'avatar-cell': cell.avatar.isAvatar, 'cell-gear': cell.isGear}]"
             :style="{width: columnWidth[j] + '%'}"
             :key="item.id + 'cell' + j">

          <!--контейнер с аватаром-->
          <div class="avatar-wrap" v-if="cell.avatar && cell.avatar.isAvatar">
            <!--автар установлен-->
            <div class="avatar-cont"
                 :style="{backgroundImage: `url(${cell.avatar.avatarLink})`}"
                 v-if="cell.avatar.avatarLink">
            </div>
            <!---->

            <!--автара нет-->
            <div class="avatar-cont" v-else>
              <group-icon></group-icon>
            </div>
            <!---->

          </div>
          <!---->

          <!--на ячейке нет методов-->
          <div v-if="!cell.text.addText">
            <router-link v-if="cell.isGear"
                         :to="cell.text.linkPrefix + cell.text.link">
              <geaar-icon></geaar-icon>
            </router-link>
            <div v-if="!cell.isMethod">

              <!--если нужно вывести одиночную ссылку
              если ссылку нужно подсветить - присваивем класс-->
              <a class="item-desc item-link"
                 :href="cell.text.link"
                 v-if="cell.text.isLink && (typeof (cell.text.link) == 'string') && !cell.text.linkArr"
                 :class="{'item-link_blue': cell.text.linkColor}" >
                <trim-item v-if="cell.text.isTrimmed"
                           :string="cell.text.text"
                           :width="cell.text.trimWidth"></trim-item>
                <span v-else>{{cell.text.text}}</span>
              </a>
              <!---->

              <!--массив линков-->
              <div class="links-array"
                   v-if="cell.text.isLink && (typeof (cell.text.link) == 'object') && cell.text.linkArr">
                <router-link class="item-desc item-link item-link_separator"
                             :class="{'colored-method-btn': cell.text.linkColor}"
                              v-if="cell.text.isLink && (typeof (cell.text.link) == 'object') && cell.text.isApp"
                              v-for="(link, k) in cell.text.link.arr"
                              :key="link[cell.text.link.linkIndex] + k"
                              :to="cell.text.link.linkPrefix + link[cell.text.link.linkIndex]">
                  <trim-item v-if="cell.text.isTrimmed"
                             :string="link[cell.text.link.linkText]"
                             :width="cell.text.trimWidth"></trim-item>
                  <span v-else>{{link[cell.text.link.linkText]}}</span>
                </router-link>
              </div>

              <!--массив пользователей-->
              <div v-if="cell.usersArray"
                   class="users-array">
                <div class="user-cont"
                     v-if="i < 3"
                     v-for="(user,i) in cell.usersArray">
                  <div class="avatar hint-cont"
                       v-if="user.avatar"
                       :style="{backgroundImage: `url(${user.avatar})`}">
                    <p class="btn-hint_bottom btn-hint">
                      <span >{{user.first_name}}</span>&nbsp;
                      <span >{{user.second_name}}</span>
                    </p>
                  </div>
                  <div v-else class="no-avatar hint-cont">
                    <user-icon></user-icon>
                    <p class="btn-hint_bottom btn-hint">
                      <span >{{user.first_name}}</span>&nbsp;
                      <span >{{user.second_name}}</span>
                    </p>
                  </div>
                </div>
                <div class="dots" v-if="cell.usersArray.length > 3">
                  <dots-icon :fill="'rgba(0, 82, 127, .5)'"></dots-icon>
                </div>
              </div>

              <div v-if="cell.confirmRoleButtons" class="confirm-role-btns">
                <button v-if="item.notify_id"
                        @click="emitRoleForConfirm(item)"
                        class="confirm-role-btn">
                  <checkAllIcon />
                  <span>{{$t('btns.acceptRole')}}</span>
                </button>
                <button v-else
                        disabled
                        class="confirm-role-btn confirm-role-btn_accepted">
                  <checkAllIcon />
                  <span>{{$t('btns.acceptRole')}}</span>
                </button>
                <button class="confirm-role-btn" @click="emitRoleForReject(item)">
                  <declineAllIcon />
                  <span>{{$t('btns.rejectRole')}}</span>
                </button>
              </div>

              <!--массив тэгов-->
              <div v-if="cell.tagsArray" class="tags-array">
                <div v-if="cell.isLinksTags" class="tag-cont" v-html="cell.tagsArray"></div>
                <button type="button"
                        class="tag-cont"
                        @click="emitTag(tag)"
                         v-if="i < 2 && !cell.isLinksTags"
                         :key="'tag' + tag.id"
                         v-for="(tag, i) in cell.tagsArray">
                  {{tag.name}}
                </button>
                <div class="dots" v-if="cell.tagsArray.length > 2">
                  ...
                </div>
              </div>

              <!---->

              <!--просто текст-->
              <p v-if="!cell.text.isLink" class="item-desc">
                <trim-item v-if="cell.text.isTrimmed"
                           class="item-desc"
                           :string="cell.text.text" :width="cell.text.trimWidth"></trim-item>
                <span v-else>
                  {{cell.text.text}}
                </span>
              </p>
              <!---->

            </div>
            <!---->

            <!--ячека с навешанным методом-->
            <div v-if="cell.isMethod">
              <p class="item-desc" v-if="!cell.method.name">
                {{cell.method.text}}
              </p>
              <button type="button"
                      v-else
                      @click="emitMethod(cell.method.name, cell.method.methodProps)"
                      class="method-btn"
                      :class="{'colored-method-btn': cell.method.colorMethod}">
                {{cell.method.text}}
              </button>
            </div>
          </div>
          <div v-else>
            <!--просто текст-->
            <p v-if="(cell.text.text + cell.text.addTextData.text).length < 70"
               class="item-with-desc hint-cont">
              <span class="item-desc">
                {{cell.text.text}}
              </span>
              <span class="item-desc_additional">
                {{cell.text.addTextData.text}}
              </span>
            </p>
            <p class="item-width_desc hint-cont"
               v-else>
              <span class="item-desc">
                <trim-item :string="cell.text.text" :width="50"></trim-item>
              </span>
              <span class="item-desc_additional">
                {{cell.text.addTextData.text.slice(0, 70 -  (cell.text.text.length + +3))}}
              </span>
<!--              <span class="btn-hint name-hint btn-hint_bottom">-->
<!--                {{cell.text.addTextData.text}}-->
<!--              </span>-->
            </p>
            <!---->
          </div>
          <!---->
        </div>
      </li>
    </ul>
    <!---->
  </section>
</template>

<script>
  import filerIcon from './Svg/filterIcon'
  import groupIcon from './Svg/cart_control/groupIcon'
  import trimItem from './trimITem'
  import {checkedClass} from "../mixins/utils/checkedClass"
  import geaarIcon from './Svg/gearIcon'
  import dotsIcon from './Svg/sidebar/dots'
  import userIcon from './Svg/users/user'
  import checkAllIcon from '../components/Svg/projects/checkAllIcon'
  import declineAllIcon from '../components/Svg/projects/declineAllIcon'
  import {mapGetters, mapMutations} from "vuex";

  export default {
    name: 'tableComponent',
    props: {
      //глобальный класс для кастомизации
      className: String,

      //ширина колонок
      columnWidth: Array,

      //массив с легендой таблицы
        //text - название столбца
        //filterMethod - имя метода для фильтрации, если нужно
        //legendSort - нужно ли сортировать колонку
        //legendDown - отсортировано вниз
        //legendUp - отсортировано вверх
        //isGear - иконка шестерни
      legend: Array,

      //маркер, что все элементы чекнуты
      allChecked: Boolean,

      //очитска ченутых
      clearChecked: Boolean,

      //список элементов
      //id
      //item - полный элемент. нужно для чекбоксов
      //dblClick - нужкн ли обоаботчки dblClick. передает id
      //dblClickPrefix - префикс для роута на даблклик
      //внутри список колонок
        //isGear - иконка шестерни с линком
        //text - Object
          //isLing- ссылка или текс
          //text
          //isTrimmed - нужно ли обрезать
          //trimWidth - до какой длины обрезать
          //addText - если нужен доп.текст
          //link

          //link может быть объектом, если нужно вывести список ссылок, тогда
            //linkPrefix - префикс для router-link или для ссылки
            //arr - массив ссылок для вывода
            //linkIndex - по какому параметру выбирать ссылку из массива
            //linkText - по какому параметру выбирать текст для ссылки из массива

        //usersArray - array url
          //массив аватаров юзера

        //tagsArray
          //массив тэгов

        //avatar - Object
          //isAvatar - нужен ли аватар
          //avatarLink
        //метод для ячейки
        //isMethod - есть ли он вообще
          // name - имя метода для прослушивания на компоненте в родителе
          //text - что писать в кнопке
          //colorMethod - нужно ли выделять голубым
          //methodProps - параметры функции
      columns: Array,

      //для страницы юзеров
      isUserPage: {
        default: false,
        required: false,
        type: Boolean,
      },
      openUser: {
        default: false,
        required: false,
        type: Boolean
      },
      confirmRoleButtons: {
        default: false,
        required: false,
        type: Boolean
      },
      tableWithButtons: {
        default: false,
        required: false,
        type: Boolean
      }

        //  isThings: Boolean,
        //  thingIcon: Component?

        //  methods: ???
        //  draggable: ???
    },
    mixins: [checkedClass],
    components: {
      filerIcon,
      groupIcon,
      trimItem,
      geaarIcon,
      dotsIcon,
      userIcon,
      checkAllIcon,
      declineAllIcon
    },
    data() {
      return {
        checkedItems: []
      }
    },
    mounted() {},
    watch: {
      clearChecked(val) {
        if (val) {
          this.checkedItems = [];
          this.removeCheckedClass('table-item_checked')
        }
      },
      allChecked() {
        if (this.allChecked) {
          this.checkedItems = [];
          this.removeCheckedClass('table-item_checked')
          this.columns.forEach(item => {
            this.checkedItems.push(item.item)
          });
          this.addCheckedClass('.table-item','table-item_checked')
        }
      }
    },
    computed: {
      ...mapGetters({
        isAdminRole: 'auth/adminRole',
      })
    },
    methods: {
      ...mapMutations({
        setIsItemProjects: 'projects/SET_IS_ITEM_PROJECTS'
      }),
      checkAll() {
        this.checkedItems = [];
        this.removeCheckedClass('table-item_checked')

        if (!this.allChecked) {
          this.columns.forEach(item => {
            this.checkedItems.push(item.item)
          });
          this.addCheckedClass('.table-item','table-item_checked')
        }
        this.$emit('checkAll');
      },
      filterItems(methodName, index) {
        this.$emit(methodName, index)
      },
      changeCheckbox(event) {
        let item = event.target.parentElement.parentElement.parentElement;
        this.toggleClass(item, 'table-item_checked');
        this.$emit('changeCheckbox', this.checkedItems);
      },
      emitMethod(name, props) {
        this.$emit(name, props)
      },
      dblClick(id, prefix, isItemProjects) {
        //проверка ТОЛЬКО для проектов и узлов под ролями
        if (!this.isAdminRole) {
          this.setIsItemProjects(isItemProjects)
        }

        if (id) {
          this.$router.push(prefix + id)
        } else {
          return
        }
      },
      emitTag(tag) {
        this.$emit('filterTag', tag)
      },
      emitRoleForReject(item) {
        this.$emit('roleForReject', item)
        // console.log('отправил roleForReject  из tableComp по item --->', item)
      },
      emitRoleForConfirm(item) {
        this.$emit('roleForConfirm', item)
        // console.log('отправил roleForConfirm из tableComp по item --->', item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table-component {
    width: 100%;
  }

  .tags-array {
    display: flex;
    align-items: center;
    margin: 0 -2px;

    .tag-cont {
      font-family: MR, Arial, sans-serif;
      font-size: 12px;
      letter-spacing: .25px;
      color: $lightBlue;
      padding: 2px 10px;
      white-space: nowrap;
      border: 1px solid $lightBlue;
      border-radius: 6px;
      margin: 0 2px;
    }

    .dots {
      border-radius: 6px;
      font-family: MR, Arial, sans-serif;
      font-size: 12px;
      color: $lightBlue;
      background: #E9F0F4;
      padding: 2px 10px;
    }
  }

  .users-array {
    display: flex;
    align-items: center;
    margin: 0 -5px;

    .user-cont {
      max-width: 24px;
      margin: 0 5px;
      background-color: #D7E3EA;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .avatar {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        //display: block;
      }

      .no-avatar {
        min-width: 20px;
        min-height: 20px;
        max-width: 20px;
        max-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      svg {
        width: 70%;
      }
    }

    .dots {
      background: rgba(239, 244, 247, 1);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin:  0 5px;
    }
  }

  .table-legend {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px 15px;

    li {
      padding-right: 15px;
    }

    svg {
      margin-left: 5px;
      cursor: pointer;
    }

    .cell1 {
      display: flex;
      padding-right: 3px;
    }
  }

  .legend-label {
    font-family: $mr;
    font-size: 13px;
    opacity: .5;
    cursor: pointer;
  }

  .filter-item {
    display: flex;
    align-items: center;
    user-select: none;
  }

  .filter-item_gear {
    width: 20px!important;
  }

  .active-filter {
    .legend-label {
      opacity: 1;
    }
  }

  .cell1 {
    width: 26px!important;
    padding: 0;
  }

  .cell2 div {
    display: flex;
    align-items: center;
    width: 90%;

    a {
      width: 100%;
    }

    p {
      width: 100%;
      /*min-height: 26px;*/
      /*max-height: 26px;*/
      height: 25px;
      line-height: 23px;

      div {
        margin: 0;
      }
    }
  }

  .table-item {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    min-height: 60px;
    /*border-bottom: 1px solid #D7E3EA;*/
    background: rgba(215, 227, 234, 0.5);
    margin: 5px 0;
    border-radius: 6px;

    & > div {
      padding-right: 15px;
    }

    &:hover {
      box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      background: white;
    }
  }

  .table-item_checked {
    background: rgba(215, 227, 234, 0.5);
  }

  .item-desc, .method-btn {
    font-family: $mm;
    font-size: 13px;
    letter-spacing: .25px;
    color: $darkBlue;
    cursor: pointer;
  }

  .item-desc_additional {
    font-family: $mm;
    font-size: 13px;
    letter-spacing: .25px;
    margin-left: 10px;
    color: $asphalt;
    cursor: pointer;
  }

  .colored-method-btn {
    color: $lightBlue
  }


  .check-cont_small .check-label::before {
    border: 2px solid $grey;
    width: 12px;
    height: 12px;
  }

  .avatar-cell {
    display: flex;
    align-items: center;
  }

  .avatar-cont {
    width: 100%!important;
    height: 20px;
    border-radius: 50%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 15px;
    background-color: #D7E3EA;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      max-width: 70%;
    }
  }

  .open-user-table {
    .cell5 {
      display: none;
    }
  }

  /*.item-desc_additional-cont {*/
    /*max-width: 60%;*/
  /*}*/

  .links-array {
    /*display: flex;*/
    /*flex-wrap: wrap;*/
    a {
      display: inline-flex;
      max-width: 100%;
      //width: min-content;
    }
  }

  .item-link_separator {
    &::after {
      content: ',  ';
      transform: translateX(-4px);
    }
  }

  .item-link_separator:last-of-type {
    &::after {
      display: none;
    }
  }

  .users-table {
    .cell2 .item-desc {
      font-family: MM, Arial, sans-serif;
      font-size: 13px;
      letter-spacing: 0.25px;
      color: #00527F;
    }
  }

  .open-user-table {
    width: calc(100% - 420px - 35px);
  }

  .users-item {
    .table-legend {
      padding: 20px;
    }

    .cell2, .cell3 {
      padding: 0 15px;
    }

    .cell4 {
      //padding-right: 15px;
    }

    .table-item {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .users-item_roles {
    .cell3 {
      padding: 0;
    }
  }

  .things-table {
    .table-legend {
      padding: 20px;
    }

    .cell2 {
      padding-left: 20px;
      padding-right: 10px;
    }

    .cell3, .cell4, .cell6 {
      padding-left: 10px;
      padding-right: 10px;
    }

    .cell7 {
      width: 30px!important;
    }
  }

  .cell-gear {
    width: 16px!important;
    height: 16px!important;
  }

  .projects-list-table {
    .cell4 div:nth-of-type(2) {
      width: calc(100% - 45px);
    }
  }

  .confirm-role-btns {
    display: flex;
    align-items: center;
    margin: 0 -8px;
    width: 275px;
    margin-left: auto;
    :hover {
      color: #fff;
      background-color: #109CF1;
      transition: 0.6s;
    }
    [disabled]:hover {
      background-color: rgba(57, 181, 74, 0.24);
    }
  }
  .confirm-role-btn {
    display: flex;
    margin: 0 8px;
    height: 40px;
    min-width: 128px !important;
    width: 128px !important;
    border: 1px solid rgba(16, 156, 241, 0.36);
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    padding-left: 14px;
    padding-right: 18px;
    color: #109CF1;

    svg {
      margin-right: 10px;
    }

    :hover {
      background-color: transparent;
    }
  }

  .confirm-role-btn_accepted {
    background: rgba(57, 181, 74, 0.24);
    padding-left: 18px;
    min-width: 128px;
    width: 128px;
    border: none;

    span {
      display: none;
    }

    svg {
      margin-right: 0;
    }
  }
  .cell4 .item-desc {
    font-size: 12px;
  }

  .legend-buttons.cell3 {
    margin-left: auto !important;
    margin-right: 10px;
    width: 300px!important;

    .legend-label {
      width: 200px;
      margin-left: auto;
      margin-right: 42px;
    }
  }
</style>
<style lang="scss">
.confirm-role-btns {
  :hover {
    svg path {
      fill: white;
      transition: 0.6s;
    }
  }
}

.confirm-role-btn_accepted[disabled]{
  background-color: rgba(57, 181, 74, 0.24);

  svg path {
    fill: #39B54A !important;
    transition: 0.6s;
  }
  :hover {
    background-color: transparent;
  }
}
</style>
